import CTNChart from '@ctn/ui/components/ctn-chart';
import { type ChartData } from 'chart.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';

import { customGenerateDoughnutConfig } from '@/helpers/charts';

import { classNameCharts, classNameTemplate } from './config';

const classNameComponent = `${classNameCharts}`;

/** Forzar el pintado del Doughnut aunque no pengan los datos  */
const dataDefault = {
	labels: [],
	datasets: [
		{
			data: [1],
			backgroundColor: ['#b5bfc7'],
			borderWidth: 2,
			borderColor: '#ffffff',
		},
	],
};

const CardChartDoughnutTemplate = ({
	className,
	classNameChart,
	data,
	title,
}: {
	readonly className?: string;
	readonly classNameChart?: string;
	readonly data?: ChartData<'doughnut'>;
	readonly title: string | React.ReactElement;
}) => {
	const classNameDoughnut = useMemo(() => classNames(classNameComponent, classNameTemplate, className), [className]);
	const classNameCTNChart = useMemo(() => classNames(classNameChart), [classNameChart]);

	return (
		<div className={classNameDoughnut}>
			<h4 className="t-ctn-card-chart__tit">{title}</h4>
			<div className="t-ctn-card-chart__chart">
				<CTNChart className={classNameCTNChart} config={customGenerateDoughnutConfig(data ?? dataDefault, Boolean(data) )} />
			</div>
		</div>
	);
};

export default CardChartDoughnutTemplate;
